import { baseUrl } from './routes';

export class ReportRoutes {
  static get reports(): string {
    return `${baseUrl}/reports`;
  }
  static get logs(): string {
    return `${baseUrl}/reports/logs`;
  }
  static get access(): string {
    return `${baseUrl}/reports/access`;
  }

  static get accessAdmin(): string {
    return `${baseUrl}/reports/access/admin`;
  }

  static get pas(): string {
    return `${baseUrl}/reports/pas`;
  }

  static get payroll(): string {
    return `${baseUrl}/reports/payroll`;
  }

  static get workedHours(): string {
    return `${baseUrl}/reports/hours`;
  }

  static get expiringInservices(): string {
    return `${baseUrl}/reports/expiration-dates`;
  }

  static get bcbaReport(): string {
    return `${baseUrl}/reports/bcba-report`;
  }

  static get clientProjection(): string {
    return `${baseUrl}/reports/client-projection`;
  }

  static get locationCpt(): string {
    return `${baseUrl}/reports/location-cpt`;
  }

  static get providerClients(): string {
    return `${baseUrl}/reports/provider-clients`;
  }

  static get ticketSupport(): string {
    return `${baseUrl}/reports/ticket-support`;
  }

  static get clientEligibility(): string {
    return `${baseUrl}/reports/client-eligibility`;
  }

  static get clientParentLogs(): string {
    return `${baseUrl}/reports/client-parent-logs`;
  }

  static get clientIncoming(): string {
    return `${baseUrl}/reports/client-incoming`;
  }

  static get clientCommunication(): string {
    return `${baseUrl}/reports/client-communication`;
  }

  static get parentResponsibility(): string {
    return `${baseUrl}/reports/parent-responsibility`;
  }

  static get objectivesStatus(): string {
    return `${baseUrl}/reports/objectives-status`;
  }

  static get supervisionMonitoring(): string {
    return `${baseUrl}/reports/supervision-monitoring`;
  }

  static get employeePayrollNotes(): string {
    return `${baseUrl}/reports/employee-payroll-notes`;
  }
  
  static get unassignedStaff(): string {
    return `${baseUrl}/reports/unassigned-staff`;
  }

  static get birthdays(): string {
    return `${baseUrl}/reports/birthdays`;
  }

  static get invoice(): string {
    return `${baseUrl}/reports/fixed-payments`;
  }

  static get clientNoteRbtByPlan(): string {
    return `${baseUrl}/reports/client-note-rbt-by-plan`;
  }

  static get transientPermissions(): string {
    return `${baseUrl}/reports/transient-permissions`;
  }
  
  static get rbtDatabase(): string {
    return `${baseUrl}/reports/rbt-database`;
  }
}
